/* ==========================================================================
   Aori K Beauty — aori-news.js
   Click a news card's ▶ → opens a YouTube/Vimeo video in a lightbox over the
   landing (with sound). The iframe is created on click (no load cost upfront)
   and removed on close (stops playback).
   ========================================================================== */
(function () {
  'use strict';

  var box, frame;

  function toEmbed(url) {
    if (!url) return null;
    url = url.trim();
    var yt = url.match(/(?:youtube\.com\/(?:watch\?v=|shorts\/|embed\/|live\/)|youtu\.be\/)([\w-]{6,})/);
    if (yt) return 'https://www.youtube.com/embed/' + yt[1] + '?autoplay=1&rel=0&playsinline=1';
    var vm = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    if (vm) return 'https://player.vimeo.com/video/' + vm[1] + '?autoplay=1';
    return url; // already an embed/other URL — use as-is
  }

  function build() {
    if (box) return;
    box = document.createElement('div');
    box.className = 'news-lightbox';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.innerHTML = '<div class="news-lightbox__frame"><button type="button" class="news-lightbox__close" aria-label="Cerrar">✕</button></div>';
    frame = box.querySelector('.news-lightbox__frame');
    box.addEventListener('click', function (e) { if (e.target === box) close(); });
    box.querySelector('.news-lightbox__close').addEventListener('click', close);
    document.body.appendChild(box);
  }

  function open(url) {
    var src = toEmbed(url);
    if (!src) return;
    build();
    var old = frame.querySelector('iframe');
    if (old) old.remove();
    var ifr = document.createElement('iframe');
    ifr.src = src;
    ifr.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture; encrypted-media');
    ifr.setAttribute('allowfullscreen', '');
    frame.appendChild(ifr);
    box.classList.add('is-open');
    document.body.classList.add('no-scroll');
  }

  function close() {
    if (!box) return;
    box.classList.remove('is-open');
    document.body.classList.remove('no-scroll');
    var ifr = frame.querySelector('iframe');
    if (ifr) ifr.remove(); // stops playback
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-news-video]');
    if (!t) return;
    e.preventDefault();
    open(t.getAttribute('data-news-video'));
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
})();
